import { type AxiosInstance } from "axios";
import useAxiosAuth from "../hooks/useAxiosAuth.ts";
import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { formatLocalDate } from "../UtilFunctions.ts";

const transformPortfolioTable = (sites: any[]) => {
  return sites.map((item: any) => ({
    ...item,
    modified_on: formatLocalDate(item.modified_on, false),
  }));
};

const fetchPortfolioSites = async (
  axiosAuth: AxiosInstance,
  portfolioId: number
) => {
  const response = await axiosAuth.get(
    `${process.env.REACT_APP_API_BASE_URL}portfolios/${portfolioId}/sites/`
  );
  return response.data ?? [];
};

export function usePortfolioTable(portfolioIds: number[], enabled: boolean = true) {
  const axiosAuth = useAxiosAuth();

  const portfolioQueries = useQueries({
    queries: portfolioIds.map((portfolioId) => ({
      queryKey: ["portfolioSites", portfolioId],
      queryFn: async () => await fetchPortfolioSites(axiosAuth, portfolioId),
      select: (data: any[]) => transformPortfolioTable(data),
      refetchOnWindowFocus: false,
      enabled: enabled && portfolioIds.length > 0,
    })),
  });

  const data = useMemo(
    () => portfolioQueries.flatMap((query) => query.data ?? []),
    [portfolioQueries]
  );

  return {
    data,
    isLoading: portfolioQueries.some((query) => query.isLoading),
    isFetching: portfolioQueries.some((query) => query.isFetching),
    isError: portfolioQueries.some((query) => query.isError),
  };
}
